import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const ListViewIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M3.33 8.86V3.33h13.34v5.53zm.84-.83h11.66V4.17H4.17zm-.84 8.64v-5.52h13.34v5.52zm.84-.84h11.66V12H4.17z"
            />
        </svg>
    </IconWrapper>
));
